import {createElem} from 'common/util/dom';

const KAPA_SCRIPT_SRC = `https://widget.kapa.ai/kapa-support-form-deflector.bundle.js`;
const BASE_SHADOW_DOM_SELECTOR = `mp-support-widget sr>> support-widget-form sr>>`;
export const KAPA_SUBJECT_ID = `support-widget-form-subject-input`;
export const KAPA_DESCRIPTION_ID = `support-widget-form-description-textarea`;

export function initKapa() {
  if (!document.head.querySelector(`script[src='${KAPA_SCRIPT_SRC}']`)) {
    const script = document.createElement(`script`);
    script.type = `text/javascript`;
    document.head.appendChild(script);
    document.head.appendChild(
      createElem(`script`, {
        src: KAPA_SCRIPT_SRC,
        async: true,
        defer: true,
        type: `text/javascript`,
        'data-integration-id': `6785cfeb-84eb-4cd2-a2de-f9df7407a8e4`,
        'data-project-color': `#4f44e0`,
        'data-main-input-query-selector': `${BASE_SHADOW_DOM_SELECTOR} mp-input[field-id=${KAPA_DESCRIPTION_ID}] sr>> #${KAPA_DESCRIPTION_ID}`,
        'data-extra-input-query-selectors': `${BASE_SHADOW_DOM_SELECTOR} div > mp-input sr>> #${KAPA_SUBJECT_ID}`,
        'data-extra-input-names': `Subject`,
        'data-submit-element-event-type': `onClick`,
        'data-submit-element-query-selector': `${BASE_SHADOW_DOM_SELECTOR} mp-button.submit-button`,
        'data-anchor-element-query-selector': `${BASE_SHADOW_DOM_SELECTOR} .remaining-form-fields`,
        'data-anchor-element-position': `afterend`,
        'data-submit-button-text-query-selector': `${BASE_SHADOW_DOM_SELECTOR} mp-button.submit-button`,
        'data-submit-button-text-override': `Next Step`,
        // TODO change text to internationalized string
        'data-pre-submit-info-text': `Our AI assistant will check if we can help you right away. If you still need assistance afterwards, you can submit a ticket to our support team.`,
        'data-debug-mode': `true`,
      }),
    );
  }
}
